import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MessageDisplay.html?raw';
import Message from '../../Operations/MessageCenter/Message';
import MessageAck from '../../Operations/MessageCenter/MessageAck';
import GenericDialog from '../GenericDialog/GenericDialog';

class MessageDisplay extends compose(_WidgetBaseSP) {
    templateString: any = template;

    messageID: string;
    messageData: Message;

    protected _callback: Function = null;

    protected _messageAck: MdsLax<InstanceType<typeof MessageAck>> = null;

    protected genericDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;

    protected _getMessageData(): void {

        this.StandbyStart();

        if (this.messageID == null) {
            this._onGetMessageDateError({ Message: "missing message ID" });
        }

        let requestData: any = { messageID: this.messageID };

        this.RequestManager.post(window.appRoot + "Operation_MessageAck/PullMessages",
            {
                "jsonData": JSON.stringify(requestData)
            },
            lang.hitch(this, this._onGetMessageDateResponse),
            lang.hitch(this, this._onGetMessageDateError),
            false
        );
    }

    protected _onGetMessageDateResponse(data: Message): void {
        //console.debug("MessageDisplay - _onGetMessageDateResponse", data);

        this.messageData = data;

        this.StandbyStop();
    }

    protected _onGetMessageDateError(error: any): void {
        console.error("MessageDisplay - _onGetMessageDateError", error.Message);
        this.StandbyStop();
    }

    //protected _applyData(): void {

    //}
/**
* Anzuzeigende Nachrichten-ID ändern und bei Bedarf Daten requesten.
 * @param bOverrideLoad Wenn leer: Nachricht wird geladen falls ID von aktueller Nachricht abweicht oder Nachricht noch nicht geladen; false: nicht laden; true: in jedem Fall laden
*/
    _setMessageIdAttr(messageId: string, bOverrideLoad?: boolean) {
        this.messageID = messageId;

        let currentId = null;
        if (this.messageData != null) {
            currentId = this.messageData.ID;
        }

        if (bOverrideLoad === true ||
            bOverrideLoad !== false && currentId != this.messageID) {
            this._getMessageData();
        }
    }
/**
* Nachricht (NICHT ID) zum Anzeigen hinterlegen.
* @param message Nachrichten-Objekt mit ID, Inhalt, Betreff, ...
*/
    _setMessageAttr(message: Message) {
        //console.debug("MessageDisplay _setMessageAttr", message);
        this.messageData = message;

        if (typeof (this.messageData) == "object") {
            this.messageID = this.messageData.ID;
        } else {
            this.messageID = null;
        }
    }
/**
* Nachricht (NICHT ID) zum Anzeigen hinterlegen.
* @param messageobjectOrId Nachricht oder ID der Nachricht
 * @param showMessage Nachricht wird sofort angezeigt; wenn false kann 
*/
    setMessage(messageobjectOrId?: string | Message, showMessage?: boolean) {
        //console.debug("MessageDisplay setMessage", messageobjectOrId, typeof (messageobjectOrId));
        if (typeof (messageobjectOrId) == "string") {
            this._setMessageIdAttr(messageobjectOrId);
        } else if (typeof (messageobjectOrId) == "object") {
            this._setMessageAttr(messageobjectOrId);
        } else {
            console.warn("MessageDisplay setMessage - falscher Datentyp?");
        }

        if (showMessage !== false) {
            this.show();
        }
    }

    show(bDisplay?: boolean) {
        let doDisplay = bDisplay !== false;

        //console.debug("MessageDisplay - show", doDisplay, this.messageID, this.messageData);

        if (this.messageID == null) {
            return;
        }

        if (this.messageData == null) {
            if (this.messageID != null) {
                this.setMessage(this.messageID, true);
                return;
            }
        }

        if (doDisplay == false) {
            this.hide();
            return;
        } 

        if (this.genericDialog == null) {
            this.genericDialog = new GenericDialog();
            this.genericDialog.destroyOnClose = false;
            this.genericDialog._setCallbackAttr(lang.hitch(this, this._onDlgCallback));
            this.genericDialog._setTopCloseBtnAttr(true);
            this.genericDialog._setCloseBtnAttr(true);
            this.genericDialog._setCancelBtnAttr(false);
            this.UiModder.domConstruct.place(this.genericDialog.domNode, this.domNode);
        }

        //this.genericDialog._setOkBtnAttr(this.messageData.is_need_confirmation == true && this.messageData.is_processed != true);
        //this.genericDialog.hideSubtitleNode(true);

        this.genericDialog._setHeaderAttr(this.messageData.message_subject_D);
        this.genericDialog._setContentAttr(this.messageData.message_content_D);
        this.genericDialog._setSubTitleAttr(this.messageData.message_content_D);

        if (this.messageData.is_need_confirmation == true && this.messageData.is_processed != true) {
            this.genericDialog.setUserdefinedButton("Bestätigen", "", lang.hitch(this, this._onDlgConfirmCallback), true);
        } else {
            this.genericDialog.setUserdefinedButton("", "", null);
        }

        this.genericDialog.show();
        
    }

    hide(): void {
        if (this.genericDialog == null) {
            return;
        }

        this.genericDialog.hide();
    }

    setCallback(callbackFct: Function) {
        this._callback = callbackFct;
    }

    protected _onDlgCallback(result: number): void {
        //console.debug("MessageDisplay - _onDlgCallback", result);
        // -1 nein // 2 ja // 4 back // 3 next // 0 schliessen/cancel
        this._processDlgCallback(result);
    }

    protected _onDlgConfirmCallback(): void {
        this._processDlgCallback(100);
    }

    protected _processDlgCallback(result: number): void {
        //console.debug("MessageDisplay - _processDlgCallback", result);

        if (this.messageData.is_processed == true) { // Achtung: falls mal eine "als ungelesen markieren"-Aktion dazukommt passt das so nicht mehr
            return;
        }
        if (this._messageAck == null) {
            this._messageAck = new MessageAck();
        }

        if (result == 1 || result == 0) { // OK / Schliessen
            this._messageAck.startup(this.messageData.identifier_key, "markAsRead")
        } else if (result == 100) {
            this._messageAck.startup(this.messageData.identifier_key, "confirm")
        }
    }

    protected _setupSubscriptions(): void {
        //this._topics.push(topic.subscribe("Messages/Loaded", lang.hitch(this, this._onMessageListenerLoaded)));
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MessageDisplay);